import { Box, Button, FormikField as Field, Input } from '@betterment/samba-react';
import { Form, Formik } from 'formik';
import { useNavigate, useSearchParams } from 'react-router-dom';
import * as Yup from 'yup';

import { TRUST_ACCOUNT_FLOW_CONFIG, useTrustAccountStep } from './TrustAccountFlow';

import { WorkflowLayout } from '../../../../Shared/layout/WorkflowLayout';

type FormValues = Yup.InferType<(typeof TRUST_ACCOUNT_FLOW_CONFIG)['trust_details']['schema']>;
export const TrustDetails: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const returnTo = searchParams.get('returnTo');

  const { values, commit } = useTrustAccountStep('trust_details');

  const initialValues: FormValues = {
    trustName: values?.trustName || '',
    trustDate: values?.trustDate || '',
  };

  const handleSubmit = (formValues: FormValues) => {
    commit(formValues);
    void navigate(
      `/add_account/self_directed_investing/investing_experience?returnTo=/add_account/self_directed_investing/ownership`
    );
  };

  return (
    <WorkflowLayout
      pageTitle="Trust details"
      workflowTitle=""
      onBack={() => navigate(-1)}
      onClose={() => (returnTo ? navigate(returnTo) : navigate('/'))}
      size="small"
    >
      <Box
        css={{
          display: 'grid',
          gap: 'space.200',
        }}
      >
        <h1>Secondary account holder details</h1>
        <Formik
          onSubmit={handleSubmit}
          initialValues={initialValues}
          validationSchema={TRUST_ACCOUNT_FLOW_CONFIG.trust_details.schema}
          validateOnChange={false}
          validateOnBlur={false}
          enableReinitialize={true}
        >
          <Form>
            <Box css={{ display: 'grid', gap: 'space.200', maxWidth: '400px' }}>
              <Field name="trustName">
                <Field.Label>Trust Name</Field.Label>
                <Field.Control>
                  <Input />
                </Field.Control>
                <Field.ErrorMessage />
              </Field>
              <Field name="trustDate">
                <Field.Label>Trust Date</Field.Label>
                <Field.Control>
                  <Input />
                </Field.Control>
                <Field.ErrorMessage />
              </Field>

              <Box css={{ display: 'flex', gap: 'space.200' }}>
                <Button type="submit" variant="solidPrimary" css={{ width: 'fit-content' }}>
                  Next
                </Button>
              </Box>
            </Box>
          </Form>
        </Formik>
      </Box>
    </WorkflowLayout>
  );
};
